/**
 * @generated SignedSource<<e189111425fb23d364ce8ab4fc479403>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CompetitionMembersDeleteMutation$variables = {
  connections: ReadonlyArray<string>;
  id: string;
};
export type CompetitionMembersDeleteMutation$data = {
  readonly removeCompetitionMember: string;
};
export type CompetitionMembersDeleteMutation = {
  response: CompetitionMembersDeleteMutation$data;
  variables: CompetitionMembersDeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v2 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v3 = {
  "alias": null,
  "args": (v2/*: any*/),
  "kind": "ScalarField",
  "name": "removeCompetitionMember",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "CompetitionMembersDeleteMutation",
    "selections": [
      (v3/*: any*/)
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "CompetitionMembersDeleteMutation",
    "selections": [
      (v3/*: any*/),
      {
        "alias": null,
        "args": (v2/*: any*/),
        "filters": null,
        "handle": "deleteEdge",
        "key": "",
        "kind": "ScalarHandle",
        "name": "removeCompetitionMember",
        "handleArgs": [
          {
            "kind": "Variable",
            "name": "connections",
            "variableName": "connections"
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "322f6896592ab3aeb525702d7ced87c2",
    "id": null,
    "metadata": {},
    "name": "CompetitionMembersDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation CompetitionMembersDeleteMutation(\n  $id: ID!\n) {\n  removeCompetitionMember(id: $id)\n}\n"
  }
};
})();

(node as any).hash = "712ad0f0d6c8cdeb769e07000b5e7dde";

export default node;
